// Modules
import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import _ from 'lodash';

// Components
import { TextInput, DateInput, CheckboxInput, SelectInput } from 'components/forms/form-elements';
import { convertArrayToOptions } from 'utils/input-utils';
import { PAYMENT_METHODS } from 'constants';
import { Form } from 'components/forms/form-structure';

// Helpers
import requiredValidation from 'utils/required-validation';
import { handleServerError } from 'utils/form-utils';


// Component
function InvoiceForm({ handleSubmit, ...props }) {
  return (
    <Form onSubmit={handleSubmit} {..._.pick(props, ['submitting', 'error', 'submitFailed'])}>
      <Field component={TextInput} name="purchaseOrderNumber" label="Purchase Order Number" />
      <div className="form-flex-row">
        <Field component={DateInput} name="invoiceDate" label="Invoice Date" />
        <Field component={DateInput} name="dueDate" label="Due Date" />
      </div>
      <Field component={SelectInput} name="paymentMethod" label="Payment Method" options={convertArrayToOptions(PAYMENT_METHODS)} />
      <Field component={CheckboxInput} name="hideBillDetails" label="Hide time report details on this invoice" />
    </Form>
  );
}

InvoiceForm.propTypes = {
  invoice: PropTypes.object,
  handleSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.object
};

export default reduxForm({
  form: 'invoice-form',
  validate: (values) => requiredValidation(['dueDate', 'invoiceDate'], values),
  onSubmitFail: handleServerError
})(InvoiceForm);
